import { Controller } from "stimulus";

export default class extends Controller {
  share(e) {
    e.preventDefault();
    let target = e.target;
    let href = target.dataset.href;
    if (!href) {
      href = target.parentNode.href;
    }
    let type = target.dataset.shareType;
    let height = target.dataset.height;
    let width = target.dataset.width;
    // Calculate the position of the popup so
    // it’s centered on the screen.
    let left = screen.width / 2 - width / 2;
    let top = screen.height / 2 - height / 2;
    let options = `height=${height},width=${width},top=${top},left=${left}resizable=1`;
    window.open(href, type, options);
  }
}
